import {capitalize, upperCaseName} from "../../../../helper/tools";
import useDeceased from "../../../../hooks/useDeceased";
import useData from "../../../../hooks/useData";
import useAuth from "../../../../hooks/useAuth";
import {getCountryList} from "../../../../api/admin/addressReq";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {getAffiliationList} from "../../../../api/pro/deceasedReq";

export default function AdminInfos({deceasedInfos, partnerInfos, adminInfos, correspondentInfos, setShowEditComplementModal}) {
    const { countryList, setCountryList } = useData();
    const { affiliationList, setAffiliationList } = useDeceased();
    const { auth } = useAuth();
    const { id } = useParams();
    const token = auth?.token;

    useEffect(() => {
        if (!affiliationList) {
        }
    }, [ affiliationList]);

    const apiAffiliationList = async () => {
        const response = await getAffiliationList(token)
        setAffiliationList(response)
    }

    useEffect(() => {
        if (!affiliationList?.length > 0) {
            apiAffiliationList()
        }
    }, [ id ]);

    useEffect(() => {
        const apiCountryList = async () => {
            if (token && (!countryList || countryList.length === 0)) {
                const response = await getCountryList(token);
                setCountryList(response);
            }
        }
        apiCountryList();
    }, [token, countryList, setCountryList]);

    const fullMaritalStatus = {
        1 : 'Marié(e)',
        2 : 'Veuf(ve)',
        3 : 'Divorcé(e)',
        4 : 'Célibataire',
        5 : 'Pacsé(e)',
        6 : 'Union libre',
        7 : 'Séparé(e)',
    };

    return (
        <>
            <div className="deceased-infos-content flex">
                {!adminInfos?.error ? (
                    <>
                        <div className="deceased-infos-column">
                            <legend><i className="fa fa-id-card-clip"/>Statut familial</legend>
                            <div>
                                <label>{fullMaritalStatus[deceasedInfos?.maritalStatus]}</label>
                            </div>
                            <div>
                                <label>{deceasedInfos?.children == 1 ? "1 enfant" : deceasedInfos?.children >1 ? deceasedInfos?.children + " enfants" : deceasedInfos?.children < 1 && "sans enfant"} </label>
                            </div>
                        </div>
                        <div className="deceased-infos-column">
                            <legend><i className="fa fa-house"/>Gestionnaire du défunt</legend>
                            <div>
                                <span>{adminInfos?.civility === "MME" ? "Madame" : "Monsieur"} {capitalize(adminInfos?.firstName)} {upperCaseName(adminInfos?.lastName)}</span>
                            </div>
                            <div>
                                <label>Lien avec le défunt: </label>
                                <span>
                                    { adminInfos?.civility === "M" ?
                                        affiliationList?.maleAffiliation[adminInfos?.familyAffiliation-1] :
                                    adminInfos?.civility === "MME" ?
                                        affiliationList?.femaleAffiliation[adminInfos?.familyAffiliation-1] :
                                        ""
                                    }
                                </span>
                            </div>
                            <div>
                                <label>Ville :</label>
                                <span>{adminInfos?.address?.city}</span>
                            </div>
                            <div>
                                <label>Téléphone :</label>
                                <span>{adminInfos?.phone}</span>
                            </div>
                        </div>
                        <div className="deceased-infos-column">
                            <legend><i className="fa fa-house"/>Destinataire des correspondances</legend>
                            <div>
                                <span>{correspondentInfos?.civility === "MME" ? "Madame" : "Monsieur"} {capitalize(correspondentInfos?.firstName)} {upperCaseName(correspondentInfos?.lastName)}</span>
                            </div>
                            <div>
                                <label>Lien avec le défunt: </label>
                                <span>
                                    { correspondentInfos?.civility === "M" ?
                                        affiliationList?.maleAffiliation[correspondentInfos?.familyAffiliation-1] :
                                        correspondentInfos?.civility === "MME" ?
                                            affiliationList?.femaleAffiliation[correspondentInfos?.familyAffiliation-1] :
                                            ""
                                    }
                                </span>
                            </div>
                            <div>
                                <label>Ville :</label>
                                <span>{correspondentInfos?.address?.city}</span>
                            </div>
                            <div>
                                <label>Téléphone :</label>
                                <span>{correspondentInfos?.phone}</span>
                            </div>
                        </div>
                        <div className="deceased-infos-column">
                            <legend><i className="fa fa-newspaper"/>Message de soutien</legend>
                            <div>
                                <span>{deceasedInfos?.thoughtsTo}</span>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="no-admin">
                        <span>Aucune information gestionnaire</span>
                        <button onClick={() => setShowEditComplementModal(true)} className="green-button">
                            <i className="fa fa-pen-to-square"/>
                            <span>Renseigner les informations</span>
                        </button>

                    </div>
                )}
            </div>
        </>
    )
}